import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconPause = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M7.992 4.508c-.547 0-1.015.195-1.406.586-.39.39-.586.86-.586 1.406v12c0 .547.195 1.016.586 1.406.39.39.86.586 1.406.586.563 0 1.04-.195 1.43-.586.39-.39.586-.86.586-1.406v-12c0-.547-.195-1.016-.586-1.406a1.945 1.945 0 0 0-1.43-.586zm8.016 0c-.563 0-1.04.195-1.43.586-.39.39-.586.86-.586 1.406v12c0 .547.195 1.016.586 1.406.39.39.867.586 1.43.586.547 0 1.015-.195 1.406-.586.39-.39.586-.86.586-1.406v-12c0-.547-.195-1.016-.586-1.406-.39-.39-.86-.586-1.406-.586z" }),
});

export { IconPause };
